import AjaxClass from "./Validation/ajaxClass";
import FormValidate from "./Validation/formValidateClass";
import MessageHandler from "./Validation/messageHandler";

export default function form() {
    /*------------ Forms -----------*/
    $("#form").on("submit", function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms");
        let terms = $("#terms").prop('checked') == true;
        let form = $(this);
        let fields = form.serializeArray();
        let specialty = {
            name: "specialty",
            value: document.getElementById("specialty").value,
        };

        let state = {
            name: "state",
            value: document.getElementById("state").value,
        };

        let city = {
            name: "city",
            value: document.getElementById("city").value,
        };

        fields.splice(fields.length - 1, 0, specialty);
        fields.splice(fields.length - 1, 0, state);
        fields.splice(fields.length - 1, 0, city);

        let validation = new FormValidate(fields);
        validation.validateAll(fields);

        let error = validation.hasError();

        MessageHandler.removeAllFormFailMessages();

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(errorMessageId);
            errorMessageId = '';
        }

        if (!error && !terms) {
            const modalSuccess = document.getElementById('success-message-forms');
            const modalSuccessDescription = document.querySelector('#success-message-forms .description');
            modalSuccess.classList.add("open-modal");
            modalSuccessDescription.innerHTML = 'Você deve estar de acordo com a nossa Política de Privacidade!';
            return false;
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr("disabled") == "disabled") {
                return false;
            }
            $(this).attr("disabled", "disabled");
            let type = "POST";
            let url = $(this).attr("action");
            let dataType = "json";
            const modalSuccess = document.getElementById(
                "success-message-forms"
            );
            const modalSuccessDescription = document.querySelector(
                "#success-message-forms .description"
            );
            const modalError = document.getElementById("error-message-forms");
            const modalDescription = document.querySelector(
                "#error-message-forms .description"
            );
            class Form extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $("#form").trigger("reset");
                        $("#form").removeAttr("disabled");
                        $("#city").html('<option value="placeholder" disabled>Selecione</option>');
                        modalSuccess.classList.add("open-modal");

                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("#form").removeAttr("disabled");
                    }
                }
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML =
                        "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("#form").removeAttr("disabled");
                }
            }
            let ajax = new Form(form, type, url, dataType, form.serialize());
            ajax.send();
        }

        return false;
    });
}
